export default __webpack_public_path__ + "locales/ro/Translations.json?hash=e914fae12b0b555944378354a58f1d54";